window.$ = window.jQuery = require('jquery');
// Angular depends on jQuery for jQueryLite
import 'angular';
// Include other libs
import 'angular-route';
import 'angular-sanitize';
import 'angular-animate';
import 'angular-touch';
import 'angular-translate';
import 'angular-utils-pagination';
import './angular-slick/slick'; // We modified slick, so use that one instead of package.json one.
import 'angular-ui-bootstrap';

import './fast-click/fastclick';

if (ENV === 'local') {
    console.log( 'loading vendors' );
}

require('script-loader!./jquery-resize/jquery.ba-resize');
require('script-loader!slick-carousel');

require('script-loader!bootstrap/dist/js/bootstrap');
